import { FC } from 'react'
import CookieConsent, { Cookies } from 'react-cookie-consent'
import classNames from 'classnames'

export const CookieConsentComponent: FC = () => {
  return (
    <CookieConsent
      containerClasses="!bg-white !text-primary !justify-center"
      location="bottom"
      contentClasses="!flex-none text-[14px] !m-[20px] break-all max-sm:w-full max-sm:px-5"
      buttonText="Accept All Cookie"
      buttonClasses={classNames(
        '!bg-primary !active:bg-blue-600 !text-white !rounded',
        'min-h-[40px] h-[40px] !px-4 text-sm'
      )}
      enableDeclineButton
      declineButtonText="Reject"
      declineButtonClasses={classNames(
        '!border !border-primary !border-solid !border-1 !bg-white !text-primary !rounded',
        'min-h-[40px] h-[40px] !px-6 text-sm'
      )}
      cookieName="cookie-consent"
      cookieValue="accept"
      declineCookieValue="reject"
      expires={150}
    >
      {`We use cookies for better performance and user experience of website
        usage. View our "Privacy Policy" for more information`}
    </CookieConsent>
  )
}
